<!-- 타일 뷰 컴포넌트 -->
<template>
    <div class="tile-view">
        <div class="tile-grid">
            <div
                v-for="item in tails"
                :key="item.equipIdx"
                class="tile-item"
                :class="{ clickable: ctrlMode }"
                @click="$emit('button-click', item)"
            >
                <div class="tile-view-container">
                    <div class="tile-view-header">
                        <div class="header-content">
                            <app-icon class="header-icon" :icon="item.icon" />
                            <span class="header-title">{{ item.equipName }}</span>
                        </div>
                    </div>
                    <div class="tile-view-body">
                        <div class="props-grid">
                            <div v-for="(prop, index) in item.props" :key="index" class="prop-item">
                                <span class="prop-name">{{ prop.propName }}</span>
                                <div class="prop-value-wrapper">
                                    <span class="prop-value">
                                        {{ prop.ptVal ? formatNumWithComma(prop.ptVal) : "-" }}
                                    </span>
                                    <span class="prop-unit">{{ formatUnit(prop.unit) }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { formatNumWithComma } from "../../utils/dataFormatter";
import { mapState } from "vuex";

export default {
    computed: {
        ...mapState({
            units: (state) => state.units,
        }),
    },
    name: "TileView",
    props: {
        tails: {
            type: Array,
            required: true,
        },
        ctrlMode: {
            type: Boolean,
            default: false,
        },
    },
    emits: ["button-click"],
    methods: {
        formatNumWithComma,
        formatUnit(unit) {
            if (!unit || unit === "-" || unit === "" || unit === null || unit === undefined) {
                return "";
            }
            return this.units.find((item) => item.value === unit)?.text;
        },
    },
};
</script>

<style lang="scss" scoped>
.tile-view {
    padding: 0.25rem 0;
}

.tile-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 0.75rem;
    width: 100%;
}

.tile-item {
    &.clickable {
        cursor: pointer;
    }

    &:hover .tile-view-container {
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
        transform: translateY(-2px);
    }

    &.clickable:active .tile-view-container {
        transform: translateY(0);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    }
}

.tile-view-container {
    width: 100%;
    height: 100%;
    background: #ffffff;
    border-radius: 6px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    overflow: hidden;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    border: 1px solid rgba(0, 0, 0, 0.06);
}

.tile-view-header {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #5775ad;
    width: 100%;
    padding: 0.4rem;
    color: white;
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;

    &::before {
        content: "";
        position: absolute;
        top: 0;
        left: -100%;
        width: 100%;
        height: 100%;
        background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.15), transparent);
        transition: left 0.5s;
    }

    .tile-item:hover &::before {
        left: 100%;
    }

    .tile-item.clickable:hover & {
        background-color: #4a6598;
    }

    .header-content {
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        z-index: 1;
    }

    .header-icon {
        font-size: 14px;
        margin-right: 0.5rem;
        opacity: 0.95;
        filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.2));
    }

    .header-title {
        font-size: 13px;
        font-weight: 600;
        letter-spacing: 0.2px;
        text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
    }
}

.tile-view-body {
    width: 100%;
    padding: 0.4rem;
    background: #ffffff;
    min-height: 100px;
}

.props-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(2, 1fr);
    gap: 0.4rem 0.6rem;
    width: 100%;
}

.prop-item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0.4rem 0.3rem;
    position: relative;

    &:not(:nth-child(3n))::after {
        content: "";
        position: absolute;
        right: -0.3rem;
        top: 0;
        bottom: 0;
        width: 1px;
        background: rgba(0, 0, 0, 0.08);
    }

    &:nth-child(-n + 3)::before {
        content: "";
        position: absolute;
        left: 0;
        right: 0;
        bottom: -0.2rem;
        height: 1px;
        background: rgba(0, 0, 0, 0.08);
    }

    .prop-name {
        font-size: 10px;
        color: #6c757d;
        margin-bottom: 0.3rem;
        font-weight: 500;
        text-transform: uppercase;
        letter-spacing: 0.3px;
        line-height: 1.2;
    }

    .prop-value-wrapper {
        display: flex;
        align-items: baseline;
        justify-content: center;
        gap: 0.15rem;
    }

    .prop-value {
        font-size: 14px;
        font-weight: 700;
        color: #2d3748;
        line-height: 1.2;
        word-break: break-word;
        text-align: center;
    }

    .prop-unit {
        font-size: 11px;
        font-weight: 500;
        color: #6c757d;
        line-height: 1.2;
    }
}

// 반응형 디자인
@media (max-width: 992px) {
    .tile-grid {
        grid-template-columns: repeat(2, 1fr);
        gap: 0.75rem;
    }

    .tile-view-container {
        margin-bottom: 0;
    }

    .props-grid {
        gap: 0.4rem 0.6rem;
    }

    .prop-item {
        padding: 0.3rem 0.2rem;

        .prop-name {
            font-size: 9px;
            margin-bottom: 0.25rem;
        }

        .prop-value {
            font-size: 12px;
        }

        .prop-unit {
            font-size: 10px;
        }
    }
}

@media (max-width: 768px) {
    .tile-grid {
        grid-template-columns: 1fr;
        gap: 0.75rem;
    }

    .tile-view-header {
        padding: 0.4rem 0.5rem;

        .header-icon {
            font-size: 14px;
            margin-right: 0.5rem;
        }

        .header-title {
            font-size: 13px;
        }
    }

    .tile-view-body {
        padding: 0.6rem 0.5rem;
    }

    .props-grid {
        gap: 0.4rem 0.6rem;
    }
}
</style>
